"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTH_DAY_FORMAT = exports.DATE_MONTH_FORMAT = exports.DATE_ONLY_FORMAT = exports.HYDRA_DATE_FORMAT = exports.TIME_FORMAT = exports.DFS_DATE_FORMAT = exports.NEW_DATE_FORMAT = exports.NEW_DATE_TIME_FORMAT = exports.DATE_TIME_FORMAT = exports.DATE_FORMAT = void 0;
// Used across the UI for human-readable dates in a consistent format
exports.DATE_FORMAT = 'DD MMM YYYY';
exports.DATE_TIME_FORMAT = 'DD MMM YYYY, hh:mm A z';
exports.NEW_DATE_TIME_FORMAT = 'MMM DD, YYYY - hh:mm A z';
exports.NEW_DATE_FORMAT = 'MMM DD, YYYY';
exports.DFS_DATE_FORMAT = 'MMM dd, yyyy';
exports.TIME_FORMAT = 'hh:mm A z';
exports.HYDRA_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
exports.DATE_ONLY_FORMAT = 'Do';
exports.DATE_MONTH_FORMAT = 'Do MMM';
exports.MONTH_DAY_FORMAT = 'MMM D';
